import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, TIME, UUID, DATETIME, DATE, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Skip from '@/plugins/sdk/resources/ScheduledPickup/Skip'
import Template from '@/plugins/sdk/resources/ScheduledPickup/Template'
import Pickup from '@/plugins/sdk/resources/Pickup'

export default class extends Resource {
  static name = 'scheduledpickup'

  static get fields () {
    return {
      id: new UUID(),
      date_from: new DATE(),
      date_to: new DATE(),
      sunday_open_time: new TIME(),
      sunday_closing_time: new TIME(),
      sunday_ready_time: new TIME(),
      monday_open_time: new TIME(),
      monday_closing_time: new TIME(),
      monday_ready_time: new TIME(),
      tuesday_open_time: new TIME(),
      tuesday_closing_time: new TIME(),
      tuesday_ready_time: new TIME(),
      wednesday_open_time: new TIME(),
      wednesday_closing_time: new TIME(),
      wednesday_ready_time: new TIME(),
      thursday_open_time: new TIME(),
      thursday_closing_time: new TIME(),
      thursday_ready_time: new TIME(),
      friday_open_time: new TIME(),
      friday_closing_time: new TIME(),
      friday_ready_time: new TIME(),
      saturday_open_time: new TIME(),
      saturday_closing_time: new TIME(),
      saturday_ready_time: new TIME(),
      is_paused: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      template: new ITEM(Template),
      skips: new COLLECTION(Skip),
      created_pickups: new COLLECTION(Pickup)
    }
  }
}
